import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import { installI18n } from '@/lang/index'

import '@/styles/index.scss'
import '@/styles/utils.scss'
import '@/assets/iconfont/iconfont.css'

const app = createApp(App)
app
  .use(store)
  .use(router)
  .use(ElementPlus, { size: 'mini' } as any)
installI18n(app)

store.dispatch('microApp/getMicroConfig').then(() => {
  app.mount('#app')
})
